// KT Milano — i18n dictionary.
// Full copy in EN + IT. Other languages fall back to English for now
// (Admin can activate/deactivate; per user brief translations arrive next).

const en = {
  brand: "HAIRTU",
  brand_powered: "Powered by KT MILANO",
  brand_tagline: "Professional Italian Haircare",
  brand_site: "www.ktmilano.com",
  service_name: "Cosmetic Hair & Scalp Assessment",
  welcome_kicker: "Cosmetic Hair & Scalp Assessment",
  welcome_title: "Your Hair. Understood.",
  welcome_sub:
    "Answer a few visual questions. Get a personalized haircare routine.",
  start: "Begin assessment",
  minutes: "~5 minutes · Free preview",
  minutes_big: "5-minute test.",
  entry_individual_title: "For You",
  entry_individual_sub: "Start your personal Hair & Scalp assessment and receive a routine crafted for your hair.",
  entry_individual_cta: "Start the assessment",
  entry_professional_title: "For Professionals",
  entry_professional_sub: "Hair salon or brand ambassador? Access the Hairtu Pro dashboard and offer complimentary in-chair assessments.",
  entry_professional_cta: "Professional access",
  hair_summary_title: "Your hair, in a snapshot",
  disclaimer:
    "This cosmetic assessment provides general haircare and product guidance based only on your answers. It does not provide medical advice, diagnosis or treatment. Consult a qualified healthcare professional for sudden, persistent or concerning hair or scalp changes.",
  // --- Landing page (final) additions ---
  landing_trust_1: "5-minute test",
  landing_trust_2: "Free preview",
  landing_trust_3: "No account required",
  landing_trust_4: "Bilingual EN · IT",
  landing_how_kicker: "How it works",
  landing_how_title: "Three steps. One personalised routine.",
  landing_step1_title: "Answer visual questions",
  landing_step1_body: "Choose the images that look most like your hair and scalp today. No forms, no jargon.",
  landing_step2_title: "See your hair, understood",
  landing_step2_body: "We turn your answers into a Hair Wellness Score, category breakdown and three cosmetic priorities.",
  landing_step3_title: "Follow your 4-step routine",
  landing_step3_body: "Shampoo · Conditioner/Mask · Primary Treatment · Booster — plus a guided 4-week plan you can actually keep.",
  landing_benefits_kicker: "What you'll get",
  landing_benefits_title: "Real routine. Zero guesswork.",
  landing_benefit_1: "A serif-clean Hair Wellness Score with an 8-category breakdown",
  landing_benefit_2: "4 essential product slots tuned to your tags — in the exact order you use them",
  landing_benefit_3: "A guided 4-week journey so change actually sticks",
  landing_benefit_4: "€{price} credit on your recommended KT Milano routine, valid 7 days",
  landing_final_kicker: "Ready when you are",
  landing_final_title: "Your best hair starts with understanding it.",
  landing_final_sub: "Take the 5-minute assessment — free preview, no account needed.",
  phase: "Phase",
  of: "of",
  continue: "Continue",
  back: "Back",
  next: "Next",
  email_kicker: "One last step",
  email_title: "Where should we send your results?",
  email_sub:
    "We'll send a short summary of your Hair Wellness Score and cosmetic priority.",
  first_name: "First name",
  email: "Email address",
  consent:
    "Yes, I would like to receive Hairtu and KT Milano haircare news, educational content and offers. I can unsubscribe at any time.",
  privacy_short:
    "We only use your email to deliver your results, confirm payment and send service messages. Marketing permission is separate and optional.",
  submit: "Reveal my results",
  submitting: "Preparing your summary…",
  results_kicker: "Your Hair Wellness Summary",
  results_thanks: "thank you for completing your cosmetic assessment.",
  overall: "Overall Hair Wellness Score",
  main_priority: "Your main cosmetic priority",
  general_statement:
    "Your results show that your hair and scalp routine could be better balanced.",
  locked_preview_kicker: "Locked · Complete cosmetic analysis",
  locked_preview_body:
    "Your full cosmetic profile, all category scores, three personalized priorities, exact KT Milano product recommendations with step-by-step usage, and your 30-day plan are ready — unlock to view.",
  unlock_headline: "Unlock Your Full Recommendations and 30-Day Plan",
  unlock_sub: "Your personalized program is ready.",
  unlock_checklist: [
    "Your complete cosmetic hair and scalp profile",
    "All personalized category scores",
    "Your three main cosmetic priorities",
    "The exact products selected for your needs",
    "Step-by-step product order and usage",
    "Your personalized 30-day routine",
    "Mistakes to avoid",
    "Progress and maintenance guidance",
    "Credit toward your recommended KT Milano routine",
  ],
  unlock_cta: "UNLOCK MY COMPLETE 30-DAY PLAN — €{price}",
  unlock_reassurance: "One-time payment · Instant access · Permanent access to this plan",
  unlock_credit_line: "Receive €{price} credit when you purchase your recommended KT Milano routine within 7 days.",
  unlock_included: "",
  comp_kicker: "Have a promo code or partner access code?",
  comp_placeholder: "Enter your promo code (e.g. KT-COMP…)",
  comp_redeem: "Apply code",
  comp_success: "Access unlocked — no payment needed.",
  comp_error_invalid: "Invalid code",
  comp_error_expired: "This code has expired or reached its limit",
  paid_open_title: "Your plan is unlocked.",
  paid_open_cta: "Open my plan",
  paid_credit_title: "Your KT Milano Shopping Bonus Is Ready",
  paid_credit_body: "You paid €{price} for your Hairtu assessment. You have received the same amount — €{price} — as a bonus to use on your next purchase from the KT Milano online shop.",
  paid_credit_value_label: "Bonus value",
  paid_credit_sub: "Use it toward your recommended routine within 7 days.",
  paid_credit_code: "Your unique bonus code",
  paid_credit_code_copy: "Copy Code",
  paid_credit_code_copied: "Copied",
  paid_credit_valid_for: "Valid for",
  paid_credit_expires_in: "Expires in",
  paid_credit_expired: "This bonus has expired",
  paid_credit_shop: "Shop KT Milano",
  copy: "Copy",
  copied: "Copied",
  share_link: "Your private link",
  scores: {
    scalp_balance: "Scalp Balance",
    hydration_need: "Hydration Need",
    structural_damage: "Structural Damage",
    reconstruction_need: "Reconstruction Need",
    heat_exposure: "Heat Exposure",
    protection_need: "Protection Need",
    buildup_tendency: "Buildup Tendency",
    shedding_concern: "Density & Shedding",
  },
  your_profile: "Your cosmetic profile",
  top_priorities: "Your three priorities",
  sub_scores: "Detailed cosmetic snapshot",
  recs_title: "Recommended KT Milano routine",
  recs_sub: "Selected from the KT Milano collection to match your answers.",
  why: "Why for you",
  how: "How to use",
  freq: "Frequency",
  mistakes_title: "Mistakes to avoid",
  progress_title: "What you can expect",
  plan_title: "Your 30-day plan",
  day: "Day",
  footer_disclaimer:
    "KT Milano — Cosmetic haircare only. Not medical advice, diagnosis or treatment.",
  lang_more: "More languages",
};

const it = {
  brand: "HAIRTU",
  brand_powered: "Powered by KT MILANO",
  brand_tagline: "Haircare professionale italiano",
  brand_site: "www.ktmilano.com",
  service_name: "Analisi Cosmetica Capelli & Cuoio Capelluto",
  welcome_kicker: "Analisi Cosmetica Capelli & Cuoio Capelluto",
  welcome_title: "I tuoi capelli. Capiti.",
  welcome_sub:
    "Rispondi a poche domande visive. Ricevi la tua routine personalizzata.",
  start: "Inizia l'analisi",
  minutes: "~5 minuti · Anteprima gratuita",
  minutes_big: "Test da 5 minuti.",
  entry_individual_title: "Per Te",
  entry_individual_sub: "Inizia la tua analisi personale di capelli e cuoio capelluto e ricevi una routine su misura.",
  entry_individual_cta: "Inizia l'analisi",
  entry_professional_title: "Per i Professionisti",
  entry_professional_sub: "Sei un salone o un brand ambassador? Accedi alla dashboard Hairtu Pro e offri analisi cosmetiche in poltrona.",
  entry_professional_cta: "Accesso professionale",
  hair_summary_title: "I tuoi capelli, in sintesi",
  disclaimer:
    "Questa analisi cosmetica offre indicazioni generali di cura dei capelli e di prodotto in base solo alle tue risposte. Non è consulenza medica, diagnosi o trattamento. Consulta un professionista qualificato per cambiamenti improvvisi, persistenti o preoccupanti a capelli o cuoio capelluto.",
  // --- Landing page (final) additions ---
  landing_trust_1: "Test di 5 minuti",
  landing_trust_2: "Anteprima gratuita",
  landing_trust_3: "Nessuna registrazione",
  landing_trust_4: "Bilingue EN · IT",
  landing_how_kicker: "Come funziona",
  landing_how_title: "Tre passi. Una routine personalizzata.",
  landing_step1_title: "Rispondi a domande visive",
  landing_step1_body: "Scegli le immagini che rappresentano meglio i tuoi capelli e il tuo cuoio capelluto oggi. Niente moduli, niente termini tecnici.",
  landing_step2_title: "Comprendi i tuoi capelli",
  landing_step2_body: "Trasformiamo le tue risposte in un Hair Wellness Score, in un'analisi per categoria e in tre priorità cosmetiche.",
  landing_step3_title: "Segui la tua routine in 4 passi",
  landing_step3_body: "Shampoo · Balsamo/Maschera · Trattamento Principale · Booster — con un piano guidato di 4 settimane facile da mantenere.",
  landing_benefits_kicker: "Cosa riceverai",
  landing_benefits_title: "Una routine vera. Zero congetture.",
  landing_benefit_1: "Il tuo Hair Wellness Score con analisi in 8 categorie",
  landing_benefit_2: "4 categorie di prodotto studiate sui tuoi tag — nell'ordine esatto d'uso",
  landing_benefit_3: "Un percorso guidato di 4 settimane per un cambiamento che dura",
  landing_benefit_4: "€{price} di credito sulla routine KT Milano consigliata, valido 7 giorni",
  landing_final_kicker: "Quando vuoi",
  landing_final_title: "I tuoi capelli migliori iniziano dal capirli.",
  landing_final_sub: "Fai l'analisi di 5 minuti — anteprima gratuita, senza registrazione.",
  phase: "Fase",
  of: "di",
  continue: "Continua",
  back: "Indietro",
  next: "Avanti",
  email_kicker: "Ultimo passo",
  email_title: "Dove ti inviamo i risultati?",
  email_sub:
    "Ti invieremo un breve riepilogo del tuo Hair Wellness Score e della tua priorità cosmetica principale.",
  first_name: "Nome",
  email: "Indirizzo email",
  consent:
    "Sì, voglio ricevere le novità Hairtu e KT Milano su capelli, consigli educativi e offerte. Posso disiscrivermi in qualsiasi momento.",
  privacy_short:
    "Usiamo la tua email solo per consegnare i risultati, confermare il pagamento e inviare messaggi di servizio. Il consenso al marketing è separato e facoltativo.",
  submit: "Mostra i miei risultati",
  submitting: "Preparo il tuo riepilogo…",
  results_kicker: "Il tuo Hair Wellness Summary",
  results_thanks: "grazie per aver completato l'analisi cosmetica.",
  overall: "Punteggio Benessere Capelli",
  main_priority: "La tua priorità cosmetica principale",
  general_statement:
    "I tuoi risultati indicano che la tua routine capelli e cuoio capelluto potrebbe essere più equilibrata.",
  locked_preview_kicker: "Bloccato · Analisi cosmetica completa",
  locked_preview_body:
    "Il tuo profilo cosmetico completo, tutti i punteggi, le tre priorità personalizzate, i prodotti KT Milano esatti con istruzioni d'uso e il piano di 30 giorni sono pronti — sblocca per vederli.",
  unlock_headline: "Sblocca i tuoi consigli completi e il programma di 30 giorni",
  unlock_sub: "Il tuo programma personalizzato è pronto.",
  unlock_checklist: [
    "Il tuo profilo cosmetico completo capelli e cuoio capelluto",
    "Tutti i punteggi personalizzati per categoria",
    "Le tue tre priorità cosmetiche principali",
    "I prodotti esatti selezionati per le tue esigenze",
    "Ordine d'uso e sequenza dettagliata dei prodotti",
    "La tua routine personalizzata di 30 giorni",
    "Errori da evitare",
    "Guida per il progresso e la manutenzione",
    "Credito sulla routine KT Milano consigliata",
  ],
  unlock_cta: "SBLOCCA IL MIO PROGRAMMA COMPLETO DI 30 GIORNI — €{price}",
  unlock_reassurance: "Pagamento unico · Accesso immediato · Accesso permanente a questo piano",
  unlock_credit_line: "Ricevi €{price} di credito acquistando la routine KT Milano consigliata entro 7 giorni.",
  unlock_included: "",
  comp_kicker: "Hai un codice promo o codice partner?",
  comp_placeholder: "Inserisci il codice promo (es. KT-COMP…)",
  comp_redeem: "Applica codice",
  comp_success: "Accesso sbloccato — nessun pagamento richiesto.",
  comp_error_invalid: "Codice non valido",
  comp_error_expired: "Codice scaduto o esaurito",
  paid_open_title: "Il tuo piano è sbloccato.",
  paid_open_cta: "Apri il piano",
  paid_credit_title: "Il tuo bonus KT Milano è pronto",
  paid_credit_body: "Hai pagato €{price} per la tua valutazione Hairtu. Hai ricevuto lo stesso importo — €{price} — come bonus da utilizzare sul tuo prossimo acquisto nello shop online KT Milano.",
  paid_credit_value_label: "Valore del bonus",
  paid_credit_sub: "Usalo sulla tua routine consigliata entro 7 giorni.",
  paid_credit_code: "Il tuo codice bonus univoco",
  paid_credit_code_copy: "Copia codice",
  paid_credit_code_copied: "Copiato",
  paid_credit_valid_for: "Valido per",
  paid_credit_expires_in: "Scade tra",
  paid_credit_expired: "Questo bonus è scaduto",
  paid_credit_shop: "Acquista su KT Milano",
  copy: "Copia",
  copied: "Copiato",
  share_link: "Il tuo link privato",
  scores: {
    scalp_balance: "Equilibrio del Cuoio Capelluto",
    hydration_need: "Bisogno di Idratazione",
    structural_damage: "Danno Strutturale",
    reconstruction_need: "Bisogno di Ricostruzione",
    heat_exposure: "Esposizione al Calore",
    protection_need: "Bisogno di Protezione",
    buildup_tendency: "Tendenza al Residuo",
    shedding_concern: "Densità & Caduta",
  },
  your_profile: "Il tuo profilo cosmetico",
  top_priorities: "Le tue tre priorità",
  sub_scores: "Panoramica cosmetica dettagliata",
  recs_title: "Routine KT Milano consigliata",
  recs_sub: "Selezionata dalla collezione KT Milano in base alle tue risposte.",
  why: "Perché è per te",
  how: "Come si usa",
  freq: "Frequenza",
  mistakes_title: "Errori da evitare",
  progress_title: "Cosa puoi aspettarti",
  plan_title: "Il tuo piano di 30 giorni",
  day: "Giorno",
  footer_disclaimer:
    "KT Milano — Solo cura cosmetica. Non è consulenza, diagnosi o trattamento medico.",
  lang_more: "Altre lingue",
};

// Fallback to English for languages the admin activates before translations arrive.
// Only the interface label is localized; body content falls back to English cleanly.
export const t = { en, it, ar: en, fa: en, fr: en, de: en, es: en, ru: en, zh: en };

export const useT = (lang) => t[lang] || t.en;
